import {
  AddProductToChargeDetails,
  AdminFeeAmountType,
  MarkupAmountType,
  TaxAmountType,
} from 'application-types';
import {
  type SupportedPaymentCurrency,
  formatCurrency,
} from 'domains-billing-currency';

import { hasPositiveAdminFeeTaxOnChargeLine } from './adminFeeTaxForChargeLine';

type TranslateFn = (key: string) => string;

export function createChargeLineTableCellRenderers({
  currency,
  t,
}: {
  currency: SupportedPaymentCurrency;
  t: TranslateFn;
}) {
  const renderFixedAmountCell = (cell: string) => {
    return formatCurrency(currency)(Number(cell));
  };

  const renderRateModifierCell = (cell: {
    value: string;
    type: MarkupAmountType | TaxAmountType | AdminFeeAmountType;
  }) => {
    const isPercentageCell =
      cell.type === MarkupAmountType.MarkupAmountTypePercentage ||
      cell.type === TaxAmountType.TaxAmountTypePercentage ||
      cell.type === AdminFeeAmountType.AdminFeeAmountTypePercentage;

    const displayValue = cell.value || '0';

    return isPercentageCell
      ? `${displayValue} %`
      : renderFixedAmountCell(displayValue);
  };

  const renderAdminFeeTaxCell = (
    cell: { value: string; type: TaxAmountType },
    row: AddProductToChargeDetails
  ) => {
    const hasAdminFee = Number(row.adminFee?.value ?? 0) > 0;
    const hasSalesTax = Number(row.tax?.value ?? 0) > 0;
    const hasAdminFeeTax = hasPositiveAdminFeeTaxOnChargeLine(cell);

    if (hasAdminFee && !hasAdminFeeTax && hasSalesTax) {
      return t('abp.charges.addProduct.table.adminFeeTax.notApplicable');
    }

    return renderRateModifierCell(cell);
  };

  return { renderFixedAmountCell, renderRateModifierCell, renderAdminFeeTaxCell };
}
